import ContainerView from "../view/container.js";

import Model from "../model/container.js";

import Animation from "../../animation/animation.js";

import {
  defaultContainerModelData,
  ContainerActionType as ActionType
} from "../const.js";

export default class Container {
  constructor(containerElement) {
    this._containerElement = containerElement;

    this._animation = new Animation();

    this._containerView = null;

    this._model = null;

    this._handleButtonClick = this._handleButtonClick.bind(this);
    this._handleChangeData = this._handleChangeData.bind(this);
  }

  init() {
    this._containerView = new ContainerView(this._containerElement);

    if (!this._containerView.getButtonElement()) {
      return;
    }

    this._containerView.setButtonClickHandler(this._handleButtonClick);

    this._model = new Model(Object.assign(
        {},
        defaultContainerModelData,
        {
          active: this._containerView.isActive()
        }
    ));
    this._model.addObserver(this._handleChangeData);
  }

  _processActivate() {
    this._animation.fadeIn(this._containerView.getListElement());
    this._containerView.activate();
  }

  _processDeactivate() {
    this._animation.fadeOut(this._containerView.getListElement());
    this._containerView.deactivate();
  }

  _handleButtonClick() {
    const action = (this._model.getData().active) ?
      ActionType.DEACTIVATE :
      ActionType.ACTIVATE;

    this._model.changeData(Object.assign(
        {},
        this._model.getData(),
        {
          active: !this._model.getData().active
        }
    ), action);
  }

  _handleChangeData(action) {
    switch (action) {
      case ActionType.ACTIVATE:
        this._processActivate();
        break;
      case ActionType.DEACTIVATE:
        this._processDeactivate();
        break;
    }
  }
}
